(() => {
 if(customElements.get('kynora-metals')) return;
 const selections=new Map();
 customElements.define('kynora-metals',class extends HTMLElement{
  connectedCallback(){
   this.select=this.querySelector('select');if(!this.select)return;
   this.key=this.dataset.form+':'+this.dataset.product;
   const saved=selections.get(this.key);
   if(saved && [...this.select.options].some(o=>o.value===saved))this.select.value=saved;
   this.onChange=()=>{selections.set(this.key,this.select.value);this.paint();this.updateMainPhoto();this.updateMobilePreview();};
   this.onClick=e=>{
    if(e.target.closest('.km-mobile-close')){this.querySelector('.km-mobile-dialog')?.close();return;}
    if(e.target.closest('.km-mobile-open')){
     const dialog=this.querySelector('.km-mobile-dialog');
     if(dialog && typeof dialog.showModal==='function' && this.mobileQuery.matches){e.preventDefault();dialog.showModal();}
     return;
    }
    const button=e.target.closest('.km-choice');if(!button)return;this.select.value=button.dataset.value;this.select.dispatchEvent(new Event('change',{bubbles:true}));};
   this.addEventListener('click',this.onClick);this.select.addEventListener('change',this.onChange);
   const swatches=this.querySelector('.km-swatches');if(swatches){swatches.hidden=false;this.select.hidden=true;}
   this.onVariant=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{if(this.isConnected)this.updateMainPhoto();});};
   this.variantEvent=typeof MainEvents!=='undefined'?MainEvents.variantUpdate:null;
   if(this.variantEvent)document.addEventListener(this.variantEvent,this.onVariant);
   this.mobileQuery=window.matchMedia('(max-width: 749px)');
   this.onViewportChange=()=>this.updateMobilePreview();
   this.mobileQuery.addEventListener('change',this.onViewportChange);
   this.onDialogClick=e=>{if(e.target===this.querySelector('.km-mobile-dialog'))e.target.close();};
   this.querySelector('.km-mobile-dialog')?.addEventListener('click',this.onDialogClick);
   this.onChange();
  }
  paint(){this.querySelectorAll('.km-choice').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.value===this.select.value)));}
  updateMainPhoto(){
   const root=this.closest('product-info');
   if(!root || this.dataset.mainPhoto!=='true')return;
   const gallery=root.querySelector('media-gallery');if(!gallery)return;
   const photo=[...this.querySelectorAll('.km-photo-map [data-metal]')].find(p=>p.dataset.metal===this.select.value);
   const old=gallery.querySelector('.km-main-photo');
   if(!photo){gallery.classList.remove('km-photo-active');if(old)old.hidden=true;return;}
   // Prefer Ella's gallery API whenever this exact photo already belongs to the gallery.
   if(photo.dataset.media && typeof gallery.setActiveMedia==='function'){
    gallery.classList.remove('km-photo-active');if(old)old.hidden=true;
    if(gallery.setActiveMedia(photo.dataset.media,false))return;
   }
   let preview=old;
   if(!preview){
    preview=document.createElement('div');preview.className='km-main-photo';preview.hidden=true;
    const link=document.createElement('a');link.target='_blank';link.rel='noopener';
    link.setAttribute('aria-label','Open selected metal photo at full size');
    const image=document.createElement('img');image.decoding='async';link.append(image);
    const back=document.createElement('button');back.type='button';back.textContent='View product gallery';
    back.addEventListener('click',()=>{gallery.classList.remove('km-photo-active');preview.hidden=true;});
    preview.append(link,back);gallery.prepend(preview);
   }
   const image=preview.querySelector('img');
   if(image.dataset.source===photo.dataset.src){preview.hidden=false;gallery.classList.add('km-photo-active');return;}
   image.dataset.source=photo.dataset.src;image.alt=photo.dataset.alt;preview.querySelector('a').href=photo.dataset.full;
   image.onload=()=>{if(image.dataset.source===photo.dataset.src && this.select.value===photo.dataset.metal && this.isConnected){preview.hidden=false;gallery.classList.add('km-photo-active');}};
   image.onerror=()=>{gallery.classList.remove('km-photo-active');preview.hidden=true;delete image.dataset.source;};
   // Show the original gallery while a new photo loads; never leave the previous metal visible.
   gallery.classList.remove('km-photo-active');preview.hidden=true;image.src=photo.dataset.src;
  }
  updateMobilePreview(){
   const preview=this.querySelector('.km-mobile-preview');if(!preview)return;
   const dialog=this.querySelector('.km-mobile-dialog');
   if(this.dataset.mobilePreview!=='true' || !this.mobileQuery?.matches){
    preview.hidden=true;if(dialog?.open)dialog.close();return;
   }
   const photo=[...this.querySelectorAll('.km-photo-map [data-metal]')].find(p=>p.dataset.metal===this.select.value);
   if(!photo){preview.hidden=true;if(dialog?.open)dialog.close();return;}
   const image=preview.querySelector('.km-mobile-image');
   const src=photo.dataset.thumb||photo.dataset.src;
   const caption=this.select.value+' Preview';
   preview.querySelector('.km-mobile-caption').textContent=caption;
   preview.querySelector('.km-mobile-open').href=photo.dataset.full;
   const large=dialog?.querySelector('.km-mobile-large');
   if(large){large.src=photo.dataset.full;large.alt=photo.dataset.alt;}
   const title=dialog?.querySelector('.km-mobile-dialog-title');if(title)title.textContent=caption;
   if(image.dataset.source===src && image.complete && image.naturalWidth>0){preview.hidden=false;return;}
   preview.hidden=true;image.dataset.source=src;image.alt=photo.dataset.alt;
   image.onload=()=>{if(this.isConnected && this.mobileQuery.matches && this.select.value===photo.dataset.metal && image.dataset.source===src)preview.hidden=false;};
   image.onerror=()=>{if(image.dataset.source===src){preview.hidden=true;delete image.dataset.source;}};
   image.src=src;
  }
  disconnectedCallback(){this.mobileQuery?.removeEventListener('change',this.onViewportChange);this.querySelector('.km-mobile-dialog')?.removeEventListener('click',this.onDialogClick);cancelAnimationFrame(this.frame);if(this.variantEvent)document.removeEventListener(this.variantEvent,this.onVariant);this.removeEventListener('click',this.onClick);this.select?.removeEventListener('change',this.onChange);}
 });
})();
